import { a as n } from "./lit-element-CwWchyls.js";
const r = class r extends n {
  constructor() {
    super(...arguments), this.role = null, this.debug = !1;
  }
  getTextLabel() {
    const s = this.childNodes;
    let e = "";
    return [...s].forEach((t) => {
      t.nodeType === Node.ELEMENT_NODE && (t.hasAttribute("slot") || (e += t.textContent)), t.nodeType === Node.TEXT_NODE && (e += t.textContent);
    }), e.trim();
  }
  emit(s, e = {}, t = {}) {
    const i = new CustomEvent(s, {
      detail: e,
      // can use event listeners on parents to listen for events from children and use a single event listener
      // also there seems to be an issue with vue where it cant listen with @EVENT-NAME for events that are not bubbling
      bubbles: !0,
      ...t
    });
    return this.dispatchEvent(i), i;
  }
};
r.VERSION = "v0.22.2";
let o = r;
export {
  o as L
};
